<template>
    <!-- main start  -->
    <div id="main">
        <!-- Main Header -->
        <MainHeader />
        
        <!-- Top Header -->
        <div class="top-header top-header-half">
            <div class="page-subtitle">
                <span></span>
            </div>
            <router-link to="/contact" class="single-page-fixed-row-link">
                <i class="fal fa-envelope"></i> <span>Get In Touch</span>
            </router-link>
        </div>
        <!-- top-header end-->
        
        <!-- wrapper  -->	
        <div id="wrapper">
            <!-- content-holder  -->	
            <div class="content-holder" data-pagetitle="Our Contacts">
                <!-- Navigation -->
                <Navigation />
                
                <!-- content-->
                <div class="content full-height cfh_nomob">
                    <!-- map-view-wrap -->
                    <div class="map-view-wrap white-bg">
                        <div class="map-view-wrap_item fl-wrap">
                            <div class="contact-details">
                                <h4>Contact Details</h4>
                                <ul>
                                    <li v-if="contactEmail">
                                        <span>01. Write  :</span>
                                        <a :href="'mailto:' + contactEmail">{{ contactEmail }}</a>
                                    </li>
                                    <li v-if="address">
                                        <span>02. Find us : </span>
                                        <a href="#">{{ address }}</a>
                                    </li>
                                    <li v-if="contactPhone">
                                        <span>03. Call:</span>
                                        <a :href="'tel:' + contactPhone">{{ contactPhone }}</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="btn float-btn act-cf">Get in Touch</div>
                        </div>
                    </div>
                    <!--map-view-wrap end -->
                    
                    <!--fixed-column-wrap-->
                    <div class="fixed-column-wrap fcw_fw">
                        <!--fixed-column-wrap-content-->
                        <div class="fixed-column-wrap-content">
                            <div class="fixed-column-wrap_bg">
                                <div class="map-container" v-if="mapLatLng">
                                    <div 
                                        id="map-single" 
                                        class="map" 
                                        :data-latlog="mapLatLng" 
                                        :data-popuptext="mapPopupText"
                                    ></div>
                                </div>
                                <div class="hero-scroll-down-notifer">
                                    <div class="scroll-down-wrap">
                                        <div class="mousey">
                                            <div class="scroller"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="fixed-column-dec"></div>
                            </div>
                            <div class="fwc-dec fwc-dec_top"></div>
                            <div class="fwc-dec fwc-dec_right"></div>
                            <div class="fixed-column-wrap_dec"></div>
                        </div>
                        <!--fixed-column-wrap-content end-->
                    </div>
                    <!--fixed-column-wrap end-->
                    
                    <div class="limit-box fl-wrap"></div>
                </div>
                <!-- content end  -->
                
                <!-- Footer -->
                <div class="height-emulator fl-wrap"></div>
                <AppFooter />
                
            </div>
            <!-- content-holder end -->
        </div>
        <!-- wrapper end -->
    </div>
    <!-- Main end -->
</template>

<script>
import MainHeader from '@/components/MainHeader.vue'
import Navigation from '@/components/Navigation.vue'
import AppFooter from '@/components/Common/AppFooter.vue'
import { useSiteDefaultsStore } from '@/stores/siteDefaultsStore'

export default {
    name: 'Contact',
    components: {
        MainHeader,
        Navigation,
        AppFooter
    },
    data() {
        return {
            map: null
        }
    },
    computed: {
        siteDefaults() {
            return useSiteDefaultsStore()
        },
        siteName() {
            return this.siteDefaults.getSiteName() || 'Our Office'
        },
        contactPhone() {
            return this.siteDefaults.getContactPhone() || ''
        },
        contactEmail() {
            return this.siteDefaults.getContactEmail() || ''
        },
        address() {
            return this.siteDefaults.getAddress() || ''
        },
        socialLinks() {
            return this.siteDefaults.getSocialLinks() || []
        },
        mapLatLng() {
            
            var latlng = `[${this.siteDefaults.getMapLat()}, ${this.siteDefaults.getMapLng()}]`
            console.log('🗺️ Map latlng:', latlng)
            return latlng
        },
        mapPopupText() {
            return `Our Location: ${this.address}.`
        }
    },
    async mounted() {
        console.log('📞 Contact page mounted successfully!')
        
        // CRITICAL: Ensure dimensions are set BEFORE map initialization
        this.$nextTick(() => {
            setTimeout(() => {
                this.ensureDimensions()
                // Then initialize map with another small delay
                setTimeout(() => {
                    this.initMap()
                }, 100)
            }, 300)
        })
    },
    beforeUnmount() {
        console.log('🗺️ Cleaning up map...')
        // Clean up map
        if (this.map) {
            try {
                this.map.remove()
            } catch (error) {
                console.warn('⚠️ Error removing map:', error)
            }
            this.map = null
        }
    },
    watch: {
        '$route'() {
            // Reinitialize map when route changes (e.g., navigating back to contact page)
            console.log('🔄 Route changed - reinitializing map')
            this.$nextTick(() => {
                setTimeout(() => {
                    this.ensureDimensions()
                    setTimeout(() => {
                        if (!this.map) {
                            this.initMap()
                        }
                    }, 100)
                }, 300)
            })
        }
    },
    methods: {
        ensureDimensions() {
            const $ = window.jQuery
            if (!$) {
                console.warn('⚠️ jQuery not available for dimension calculation')
                return
            }
            
            console.log('📐 Ensuring dimensions are set...')
            
            // Force fixed-column dimensions
            if ($(".fixed-column-wrap").length) {
                const height = $(window).outerHeight(true)
                $(".fixed-column-wrap").css({
                    height: height + 'px'
                })
                console.log('✅ Fixed column height set to:', height)
            }
            
            // Ensure map container has explicit height
            const mapContainer = $("#map-single")
            if (mapContainer.length) {
                const parentHeight = mapContainer.parent().height()
                if (parentHeight > 0) {
                    mapContainer.css({
                        height: '100%',
                        minHeight: '400px'
                    })
                    console.log('✅ Map container dimensions set')
                }
            }
            
            // Force a reflow
            void document.body.offsetHeight
        },
        
        initMap() {
            const $ = window.jQuery
            const L = window.L
            
            if (!$ || !L) {
                console.warn('⚠️ jQuery or Leaflet not available')
                setTimeout(() => this.initMap(), 200)
                return
            }
            
            const mapContainer = document.getElementById('map-single')
            if (!mapContainer) {
                console.warn('⚠️ Map container #map-single not found in DOM')
                return
            }
            
            // Verify container has dimensions
            const containerWidth = mapContainer.offsetWidth
            const containerHeight = mapContainer.offsetHeight
            console.log('🗺️ Map container dimensions:', containerWidth, 'x', containerHeight)
            
            if (containerWidth === 0 || containerHeight === 0) {
                console.error('❌ Map container has zero dimensions! Width:', containerWidth, 'Height:', containerHeight)
                console.log('⚠️ Retrying in 500ms...')
                setTimeout(() => this.initMap(), 500)
                return
            }
            
            // Clean up any existing map instance first
            if (this.map) {
                console.log('🗺️ Removing existing map instance')
                try {
                    this.map.remove()
                } catch (e) {
                    console.warn('⚠️ Error removing old map:', e)
                }
                this.map = null
            }
            
            // Clear the container's _leaflet_id to allow re-initialization
            if (mapContainer._leaflet_id) {
                delete mapContainer._leaflet_id
            }
            
            try {
                // Get data attributes and parse coordinates
                let latlog = $('#map-single').data('latlog')
                const popupTextit = $('#map-single').data('popuptext')
                
                // Parse string coordinates to array if needed
                if (typeof latlog === 'string') {
                    latlog = JSON.parse(latlog)
                }
                
                console.log('🗺️ Initializing map with coordinates:', latlog)
                
                // Initialize map
                this.map = L.map('map-single', {
                    scrollWheelZoom: false,
                    zoomControl: true
                }).setView(latlog, 11)
                
                // Add tile layer
                L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png', {
                    attribution: '&copy; OpenStreetMap contributors',
                    maxZoom: 19
                }).addTo(this.map)
                
                // Add marker
                const greenIcon = L.icon({
                    iconUrl: '/assets/img/marker.png',
                    iconSize: [64, 92],
                    popupAnchor: [0, -26]
                })
                
                L.marker(latlog, {
                    icon: greenIcon
                }).addTo(this.map).bindPopup(popupTextit)
                
                // Force map to recalculate size multiple times
                setTimeout(() => {
                    if (this.map) {
                        this.map.invalidateSize()
                    }
                }, 100)
                
                setTimeout(() => {
                    if (this.map) {
                        this.map.invalidateSize()
                    }
                }, 500)
                
                console.log('✅ Map initialized successfully')
            } catch (error) {
                console.error('❌ Failed to initialize map:', error)
            }
        }
    }
}
</script>
